<template>
    <div class="sch-modal-footer">
        <button v-if="showConfirm" type="button" class="btn btn-primary" :disabled="disabled" @click="$emit('confirm')">
            {{ confirmLabel || $t("저장") }}
        </button>
        <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
            {{ cancelLabel || $t("닫기") }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        confirmLabel: { type: String, default: "" },
        cancelLabel: { type: String, default: "" },
        showConfirm: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.sch-modal-footer {
    display: flex;
    flex: 1;
    gap: 8px;
}
.sch-modal-footer .btn {
    flex: 1;
}
</style>
